import React from "react";
import { background, Box, Text, useColorModeValue } from "@chakra-ui/react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import theme from "../../theme";
import "./chartStyles.css"; // Import the CSS file

const NumberToHourMin = (value) => {
  const hour = Math.floor(value);
  const min = Math.round((value % 1) * 60);
  return `${hour} hours${min > 0 ? ` and ${min} minutes` : ``}`;
}

const CustomBarChart = ({ data, title, bars, yLabel }) => {
  const bgColor = useColorModeValue('chart-box', 'chart-box-dark');
  const textColor = useColorModeValue("chart-title", "chart-title-dark");
  const axisColor = useColorModeValue("chart-axis", "chart-axis-dark");
  const chartColors = Object.values(theme.colors.chartColors);
  const dividerColor = useColorModeValue(theme.colors.dividerColor.light, theme.colors.dividerColor.dark);

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600" color={textColor}>
        {title}
      </Text>
      <Box className="divider"></Box>
      <ResponsiveContainer width="100%" height={300} minWidth="200px">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis
            label={{
              value: yLabel,
              angle: -90,
              position: 'insideLeft',
              offset: 10,
              style: { textAnchor: 'middle'}
            }}
          />
          <Tooltip
            formatter={title.includes("Time") ? (numericTime) => NumberToHourMin(numericTime) : '' }
            labelFormatter={(label, payload) => {
              const tooltipTitle = payload && payload.length > 0 && payload[0].payload.fullname ? `${payload[0].payload.fullname}` : label;
              return (
                <span className={'tooltip-title'} >
                  {tooltipTitle}
                </span>
              );
            }}

          />
          {bars.map((bar, index) => (
            <Bar key={index} dataKey={bar.dataKey} stackId={bar.stackId} fill={chartColors[index % chartColors.length]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
      <Box display="flex" justifyContent="center" mt={4} className='chart-legend'>
        {bars.map((bar, index) => (
          <Box key={index} display="flex" alignItems="center" mr={4}>
            <Box
              width="12px"
              height="12px"
              backgroundColor={chartColors[index % chartColors.length]}
              borderRadius="50%"
              mr={2}
              border="1px solid #000"
            />
            <Text fontSize="md" color={textColor}>
              {bar.name}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CustomBarChart;
